<template>
  <div id="kt_content" class="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
    <div class="kt-subheader   kt-grid__item">
      <div class="kt-container  kt-container--fluid ">
        <div class="kt-subheader__main">
          <h3 class="kt-subheader__title">
            API
          </h3>
          <span class="kt-subheader__separator kt-hidden" />
          <div class="kt-subheader__breadcrumbs">
            <router-link to="/" class="kt-subheader__breadcrumbs-home">
              <i
                class="flaticon2-shelter"
                @click="trackCustomEvent({ action: 'clicked', target: 'breadcrumbs_content', linkTo: 'overview' })"
              />
            </router-link>
            <span class="kt-subheader__breadcrumbs-separator" />
            <router-link :to="`/dashboard/${projectId}`" class="kt-subheader__breadcrumbs-link">
              <span @click="trackCustomEvent({ action: 'clicked', target: 'breadcrumbs_content', linkTo: 'dashboard' })">
                Project
              </span>
            </router-link>
            <span class="kt-subheader__breadcrumbs-separator" />
            <span class="kt-subheader__breadcrumbs-link kt-subheader__breadcrumbs-link--active">API</span>
          </div>
        </div>
      </div>
    </div>
    <!-- begin:: Content -->
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
      <!--begin:: Portlet-->
      <div class="kt-portlet">
        <div class="kt-portlet__body">
          <LoadingSpinner v-if="!isLoaded" />
          <Projectcomponent v-else :project-detail-state="projectDetailState" />
        </div>
      </div>
      <!--end:: Portlet-->

      <div class="kt-align-right kt-margin-b-10">
        <DatePicker v-model="dateRange" @input="updateRange" />
      </div>

      <div class="row">
        <div class="col-xl-6">
          <div class="kt-portlet kt-portlet--height-fluid">
            <div class="kt-portlet__head kt-portlet__head--noborder">
              <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title">
                  Request Count
                </h3>
              </div>
            </div>
            <LoadingSpinner v-if="isProjectRequestLoading" />
            <div v-else class="kt-portlet__body kt-portlet__body--fluid justify-content-center">
              <ProjectRequestLinechart v-if="projectRequestLineChartData" :chart-data="projectRequestLineChartData" />

              <div v-else class="d-flex flex-column justify-content-center align-items-center kt-label-font-color-1" style="height: 200px">
                <ChartIcon />
                <h5><span>No Data Available</span></h5>
                <p>Try selecting a different time period.</p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-6">
          <!--begin:: Widgets/Order Statistics-->
          <div class="kt-portlet kt-portlet--height-fluid">
            <div class="kt-portlet__head kt-portlet__head--noborder">
              <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title">
                  Response Time
                </h3>
              </div>
            </div>
            <LoadingSpinner v-if="isProjectResponseLoading" />
            <div v-else class="kt-portlet__body kt-portlet__body--fluid justify-content-center">
              <ProjectResponseLinechart v-if="projectResponseLineChartData" :chart-data="projectResponseLineChartData" />
              <div v-else class="d-flex flex-column justify-content-center align-items-center kt-label-font-color-1" style="height: 200px">
                <ChartIcon />
                <h5><span>No Data Available</span></h5>
                <p>Try selecting a different time period.</p>
              </div>
            </div>
          </div>

          <!--end:: Widgets/Order Statistics-->
        </div>
      </div>

      <!--begin::Activated Services-->
      <ActivatedTable :range="rangeOfErrorCount" />
      <!--end::Activated Services-->

      <!-- <div class="kt-space-40" /> -->
      <div v-for="(column, idx) in usageQuotaChartData" :key="idx" class="row">
        <div class="kt-container  kt-container--fluid ml-n">
          <div class="kt-subheader__main">
            <div class="kt-space-20" />
            <div class="kt-subheader__title kt-margin-b-10">
              <h5>Token: {{ name[tokens[idx]] }}</h5>
              <!--              <h5>{{ tokenName(tokens[idx])[idx] }}</h5>-->
              <!-- <h5>Token:</h5> -->
            </div>
          </div>
        </div>
        <div class="col-xl-6">
          <!--begin:: Widgets/Order Statistics-->
          <div class="kt-portlet kt-portlet--height-fluid">
            <div class="kt-portlet__head kt-portlet__head--noborder">
              <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title">
                  Compare usage to quotas
                </h3>
              </div>
            </div>
            <div class="kt-portlet__body kt-portlet__body--fluid justify-content-center">
              <GChart
                type="ColumnChart"
                :data="usageQuotaChartData[idx]"
                :options="usageQuotaChartOptions"
                :create-chart="(el, google) => new google.visualization.ColumnChart(el)"
                class="w-100"
                style="height: 250px;"
              />
            </div>
          </div>

          <!--end:: Widgets/Order Statistics-->
        </div>

        <div class="col-xl-6">
          <!--begin:: Widgets/Order Statistics-->
          <div class="kt-portlet kt-portlet--height-fluid">
            <div class="kt-portlet__head kt-portlet__head--noborder">
              <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title">
                  Blocked Rate
                </h3>
              </div>
            </div>
            <div class="kt-portlet__body kt-portlet__body--fluid justify-content-center">
              <GChart
                type="ColumnChart"
                :data="blockedCountChartData[idx]"
                :options="blockedCountChartOptions"
                :create-chart="(el, google) => new google.visualization.ColumnChart(el)"
                class="w-100"
                style="height: 250px;"
              />
            </div>
          </div>

          <!--end:: Widgets/Order Statistics-->
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <a
            target="_blank"
            href="https://demo.nlp.insightera.co.th"
            @click="trackCustomEvent({ action: 'clicked', target: 'demo_content', linkTo: 'demo' })"
          >
            <div class="kt-portlet kt-iconbox kt-iconbox--wave">
              <div class="kt-portlet__body">
                <div class="kt-iconbox__body">
                  <div class="kt-iconbox__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect x="0" y="0" width="24" height="24" />
                        <path d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
                        <path d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z" fill="#000000" fill-rule="nonzero" />
                      </g>
                    </svg>
                  </div>
                  <div class="kt-iconbox__desc">
                    <h3 class="kt-iconbox__title">
                      API Demo
                    </h3>
                    <div class="kt-iconbox__content">
                      Explore available services
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-6">
          <a
            target="_blank"
            href="https://nlp.insightera.co.th/docs/v1.0/"
            @click="trackCustomEvent({ action: 'clicked', target: 'docs_content', linkTo: 'docs' })"
          >
            <div class="kt-portlet kt-iconbox kt-iconbox--wave">
              <div class="kt-portlet__body">
                <div class="kt-iconbox__body">
                  <div class="kt-iconbox__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <polygon points="0 0 24 0 24 24 0 24" />
                        <path d="M4.85714286,1 L11.7364114,1 C12.0910962,1 12.4343066,1.12568431 12.7051108,1.35473959 L17.4686994,5.3839416 C17.8056532,5.66894833 18,6.08787823 18,6.52920201 L18,19.0833333 C18,20.8738751 17.9795521,21 16.1428571,21 L4.85714286,21 C3.02044787,21 3,20.8738751 3,19.0833333 L3,2.91666667 C3,1.12612489 3.02044787,1 4.85714286,1 Z M8,12 C7.44771525,12 7,12.4477153 7,13 C7,13.5522847 7.44771525,14 8,14 L15,14 C15.5522847,14 16,13.5522847 16,13 C16,12.4477153 15.5522847,12 15,12 L8,12 Z M8,16 C7.44771525,16 7,16.4477153 7,17 C7,17.5522847 7.44771525,18 8,18 L11,18 C11.5522847,18 12,17.5522847 12,17 C12,16.4477153 11.5522847,16 11,16 L8,16 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
                        <path d="M6.85714286,3 L14.7364114,3 C15.0910962,3 15.4343066,3.12568431 15.7051108,3.35473959 L20.4686994,7.3839416 C20.8056532,7.66894833 21,8.08787823 21,8.52920201 L21,21.0833333 C21,22.8738751 20.9795521,23 19.1428571,23 L6.85714286,23 C5.02044787,23 5,22.8738751 5,21.0833333 L5,4.91666667 C5,3.12612489 5.02044787,3 6.85714286,3 Z M8,12 C7.44771525,12 7,12.4477153 7,13 C7,13.5522847 7.44771525,14 8,14 L15,14 C15.5522847,14 16,13.5522847 16,13 C16,12.4477153 15.5522847,12 15,12 L8,12 Z M8,16 C7.44771525,16 7,16.4477153 7,17 C7,17.5522847 7.44771525,18 8,18 L11,18 C11.5522847,18 12,17.5522847 12,17 C12,16.4477153 11.5522847,16 11,16 L8,16 Z" fill="#000000" fill-rule="nonzero" />
                      </g>
                    </svg>
                  </div>
                  <div class="kt-iconbox__desc">
                    <h3 class="kt-iconbox__title">
                      API Document
                    </h3>
                    <div class="kt-iconbox__content">
                      For all available services
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <!-- end:: Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { GChart } from 'vue-google-charts'
import DatePicker from '../components/Datepicker'
import Projectcomponent from '../components/ProjectDetail'
import moment from 'moment'
import util from '../utils'
import ProjectRequestLinechart from '../components/ProjectRequestLinechart'
import ProjectResponseLinechart from '../components/ProjectResponseLinechart'
import numeral from 'numeral'
import LoadingSpinner from '../components/LoadingSpinner'
import ChartIcon from '../components/ChartIcon'
import ActivatedTable from '../components/ActivatedServicesTable'

export default {
  filters: {
    number (value) {
      if (value) {
        return numeral(value).format('0,0')
      } else {
        return value
      }
    }
  },
  components: {
    GChart,
    ProjectRequestLinechart,
    ProjectResponseLinechart,
    DatePicker,
    Projectcomponent,
    LoadingSpinner,
    ChartIcon,
    ActivatedTable
  },
  data () {
    return {
      isLoaded: false,
      project: {
        detail: {},
        errorCount: 0
      },
      activatedServices: [],
      dateRange: {
        startDate: moment().subtract(7, 'd').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
      },
      selected: {
        start: moment().subtract(7, 'd').format('x'),
        stop: moment().format('x'),
        binSize: 0
      },
      projectRequestLineChartData: [],
      projectResponseLineChartData: [],
      tokens: [],
      usageQuotaChartData: [],
      usageQuotaChartOptions: {
        // title: 'Compare usage to quotas',
        // titleTextStyle: {
        //   fontSize: 13
        // },
        fontName: 'Open Sans',
        fontSize: 11,
        legend: {
          position: 'top',
          alignment: 'end'
        },
        vAxis: {
          title: 'Percent',
          maxValue: 100,
          ticks: [0, 50, 100],
          gridlines: {
            count: 4
          }
        },
        colors: ['#5967d9', '#ed4179', '#23c7b5']
      },
      blockedCountChartData: [],
      blockedCountChartOptions: {
        fontName: 'Open Sans',
        fontSize: 11,
        legend: {
          position: 'none'
        },
        bar: { groupWidth: '75%' },
        hAxis: {
          title: 'Service'
        },
        vAxis: {
          title: 'Count',
          maxValue: 100,
          ticks: [0, 50, 100],
          gridlines: {
            count: 4
          }
        },
        colors: ['#ed4179']
      },
      isTableLoading: true,
      isProjectRequestLoading: true,
      isProjectResponseLoading: true,
      name: {}
    }
  },
  computed: {
    ...mapGetters({
      getProjectDetailState: 'project/getProjectDetailState'
    }),
    projectId () {
      return this.$route.params.projectId
    },
    binSize () {
      return Math.floor(((this.selected.stop - this.selected.start) / 5) / 1000)
    },
    rangeOfErrorCount () {
      return {
        start: 0,
        stop: Number(moment().format('x'))
      }
    },
    projectDetailState () {
      return this.getProjectDetailState[this.projectId]
    }
  },
  watch: {
    selected: {
      handler () {
        this.getProjectUsage()
        this.getProjectResponse()
      },
      deep: true
    },
    async $route () {
      this.isLoaded = false
      await this.projectErrorCount
      await this.getProjectUsage()
      await this.getProjectResponse()
      this.isLoaded = true
    }
  },
  async mounted () {
    this.getProjectUsage()
    this.getProjectResponse()
    this.getUsageQuota()
    this.isLoaded = true
  },
  methods: {
    ...mapActions({
      getProjectUsageRequest: 'project/getProjectUsage',
      getProjectResponseRequest: 'project/getProjectResponse',
      getUsageQuotaRequest: 'project/getUsageQuota',
      getBlockedCountRequest: 'project/getBlockedCount',
      getSingleTokenDetailRequest: 'project/getSingleTokenDetail',
      trackCustomEvent: 'user/trackCustomEvent'
    }),
    async tokenName (tokens) {
      if (tokens) {
        for (const i in tokens) {
          const resp = await this.getSingleTokenDetailRequest(tokens[i])
          if (resp.data && resp.data.name) {
            this.name = {
              ...this.name,
              [tokens[i]]: resp.data.name
            }
          }
        }
        return this.name
      }
    },
    updateRange (values) {
      this.selected.start = moment(values.start).format('x')
      this.selected.stop = moment(values.end).format('x')
    },
    async getProjectUsage () {
      const responseData = await this.getProjectUsageRequest({
        projectId: this.projectId,
        start: Number(this.selected.start),
        stop: Number(this.selected.stop),
        binSize: this.binSize
      })
      this.projectRequestLineChartData = responseData
      await util.sleep(2000)
      this.isProjectRequestLoading = false
    },
    async getProjectResponse () {
      const responseData = await this.getProjectResponseRequest({
        projectId: this.projectId,
        start: Number(this.selected.start),
        stop: Number(this.selected.stop),
        binSize: this.binSize
      })
      this.projectResponseLineChartData = responseData
      await util.sleep(2000)
      this.isProjectResponseLoading = false
    },
    async getUsageQuota () {
      // TODO > components
      const responseData = await this.getProjectDetailState[this.projectId]
      if (responseData) {
        responseData.tokens.map(t => { this.tokens.push(t.token) })
        await this.tokenName(this.tokens)
        for (const data of responseData.tokens) {
          const requestData = {
            projectId: this.projectId,
            token: data.token
          }
          const usageQuota = await this.getUsageQuotaRequest(requestData)
          const blockedCount = await this.getBlockedCountRequest(requestData)
          const headerQuota = [['service', 'month', 'day', 'minute']]
          if (usageQuota) {
            usageQuota.map(data => {
              const { service, intervals } = data
              const percentage = intervals.map(interval => {
                return util.trimDecimal(interval.percentage)
              })
              headerQuota.push([service.substring(5)].concat(percentage))
            })
          } else {
            headerQuota.push([' ', 0, 0, 0])
          }
          this.usageQuotaChartData.push(headerQuota)

          const headerBlocked = [['service', 'count']]
          if (blockedCount) {
            blockedCount.map(data => {
              headerBlocked.push([data.Name, data.Count])
            })
          } else {
            headerBlocked.push([' ', 0])
          }
          this.blockedCountChartData.push(headerBlocked)
        }
      } else {
        this.tokens = null
      }
    }
  }
}
</script>

<style>
  .ml-n {
    margin-left: -1.5rem !important;
  }
  .kt-subheader {
    margin-top: 0px;
  }
</style>
